import { Row } from '@tanstack/react-table';

declare module '@tanstack/react-table' {
	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	interface ColumnMeta<TData, TValue> {
		width?: string;
		disableRowLink?: boolean;
	}
}

export interface ActionMenuItem<T> {
	name: string;
	onClick: (row: T) => void;
	isDisabled?: (row: T) => boolean;
}

export interface PaginationOptions {
	initialPageSize?: number;
	showFromCount?: number;
	options?: number[];
}

export interface ColumnSizeOptions {
	minSize?: number;
	maxSize?: number;
}

export interface FilterSettings<T> {
	groups: IFilterGroup<T>[];
	treatGroupsAsSingle: boolean;
}

export interface IFilterGroup<T> {
	columnId: string;
	filterFn?: (row: Row<T>, id: string, value: any) => boolean;
	filters?: IFilter<T>[];
	defaultSelected?: string;
	groupCanBeCleared?: boolean;
}

export interface IFilter<T> {
	id?: string;
	text: string;
	value: any;
	selected: boolean;
	showCount?: boolean;
	count?: number;
	countFn?: (data: T[]) => number;
}

export enum ExcelExportType {
	ProductUser = 'ProductUser',
	PowerOrder = 'PowerOrder',
	BiogasOrder = 'BiogasOrder',
	PowerTrade = 'PowerTrade',
	BiogasTrade = 'BiogasTrade',
}

export interface ExcelExportOptions {
	type: ExcelExportType;
	buttonTitle: string;
	documentName: string;
}
